import * as React from 'react'

import type { SVGProps } from 'react'

const SvgGelIconArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    stroke="currentColor"
    fill="currentColor"
    strokeWidth={0}
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M26.7 12.6 16 23.2 5.3 12.6V8.8h21.4v3.8z" stroke="none" />
  </svg>
)

export default SvgGelIconArrowDown
